import {config, get, capitalize, useLocation, findIndex, split} from 'helpers';

export function usePages() {
  const {pathname} = useLocation();
  const parts = pathname.split('/').filter(Boolean);
  for (let i = 0; i < pages.length; i++) {
    const index = findIndex(pages[i], page => page[0] === pathname);
    if (index !== -1) {
      return {
        current: index + 1,
        next: get(pages[i][index + 1], '0'),
        prev: get(pages[i][index - 1], '0'),
        title: get(pages[i][index], '1') || split(parts[1], '-').map(capitalize).join(' '),
        total: pages[i].length
      };
    }
  }
}

const pages = [
  [
    ['/welcome/', 'Welcome'],
    ['/welcome/reality-check/'],
    ['/welcome/life-chart/', 'My Life Chart'],
    ['/welcome/quiz/intro/', 'Clarity & Focus Quiz'],
    ['/welcome/quiz/vision/', 'Vision'],
    ['/welcome/quiz/what-and-why/', 'What and Why'],
    ['/welcome/quiz/goals/', 'Goals'],
    ['/welcome/quiz/plan/', 'Plan'],
    ['/welcome/quiz/progress/', 'Progress'],
    ['/welcome/quiz/productivity/', 'Productivity'],
    ['/welcome/quiz/drive/', 'Drive'],
    ['/welcome/quiz/motivation/', 'Motivation'],
    ['/welcome/score/', 'My Score']
  ],
  [
    [`/${config.clarityModule}/`, capitalize(config.clarityModule) + ' Intro'],
    [`/${config.clarityModule}/how-are-you/`],
    [`/${config.clarityModule}/reality-check/`],
    [`/${config.clarityModule}/reality-check/continue/`],
    [`/${config.clarityModule}/career/`],
    [`/${config.clarityModule}/career/goal-actions/`, 'My Career Goal & Actions'],
    [`/${config.clarityModule}/relationships/`],
    [`/${config.clarityModule}/relationships/goal-actions/`, 'My Relationships Goal & Actions'],
    [`/${config.clarityModule}/health/`],
    [`/${config.clarityModule}/health/goal-actions/`, 'My Health Goal & Actions'],
    [`/${config.clarityModule}/wealth/`],
    [`/${config.clarityModule}/wealth/goal-actions/`, 'My Wealth Goal & Actions'],
    [`/${config.clarityModule}/social/`],
    [`/${config.clarityModule}/social/goal-actions/`, 'My Social Goal & Actions'],
    [`/${config.clarityModule}/spirituality/`],
    [`/${config.clarityModule}/spirituality/goal-actions/`, 'My Spirituality Goal & Actions'],
    [`/${config.clarityModule}/lifestyle/`],
    [`/${config.clarityModule}/lifestyle/goal-actions/`, 'My Lifestyle Goal & Actions'],
    [`/${config.clarityModule}/growth/`],
    [`/${config.clarityModule}/growth/goal-actions/`, 'My Growth Goal & Actions'],
    [`/${config.clarityModule}/whats-next/`, 'What\'s Next']
  ],
  [
    [`/${config.identityModule}/`, capitalize(config.identityModule) + ' Intro'],
    [`/${config.identityModule}/values/`],
    [`/${config.identityModule}/values/ask-yourself/`, 'Ask Yourself'],
    [`/${config.identityModule}/values/living-your-values/`, 'Living Your Values'],
    [`/${config.identityModule}/values/go-deeper/`, 'Go Deeper'],
    [`/${config.identityModule}/beliefs/`],
    [`/${config.identityModule}/beliefs/inquiry-1/`, 'Inquiry 1'],
    [`/${config.identityModule}/beliefs/inquiry-2/`, 'Inquiry 2'],
    [`/${config.identityModule}/beliefs/inquiry-3/`, 'Inquiry 3'],
    [`/${config.identityModule}/habits/`],
    [`/${config.identityModule}/habits/inquiry-1/`, 'Inquiry 1'],
    [`/${config.identityModule}/habits/go-deeper/`, 'Go Deeper'],
    [`/${config.identityModule}/strengths/`],
    [`/${config.identityModule}/strengths/inquiry-1/`, 'Inquiry 1'],
    [`/${config.identityModule}/strengths/inquiry-2/`, 'Inquiry 2'],
    [`/${config.identityModule}/strengths/summary/`, 'Summary'],
    [`/${config.identityModule}/strengths/go-deeper/`, 'Go Deeper'],
    [`/${config.identityModule}/passion/`],
    [`/${config.identityModule}/passion/inquiry-1/`, 'Inquiry 1'],
    [`/${config.identityModule}/passion/inquiry-2/`, 'Inquiry 2'],
    [`/${config.identityModule}/passion/summary/`, 'Summary'],
    [`/${config.identityModule}/passion/go-deeper/`, 'Go Deeper'],
    [`/${config.identityModule}/purpose/`],
    [`/${config.identityModule}/purpose/inquiry-1/`, 'Inquiry 1'],
    [`/${config.identityModule}/purpose/go-deeper/`, 'Go Deeper'],
    [`/${config.identityModule}/dreams/`],
    [`/${config.identityModule}/dreams/inquiry-1/`, 'Inquiry 1'],
    [`/${config.identityModule}/dreams/inquiry-2/`, 'Inquiry 2'],
    [`/${config.identityModule}/vision/`],
    [`/${config.identityModule}/vision/my-life/`, 'My Life Vision'],
    [`/${config.identityModule}/vision/my-vision-and-me/`, 'My Vision And Me']
  ]
];
